<template>
  <v-dialog v-model="show" :max-width="maxWidth" :lazy="lazy">
    <v-card>
      <v-card-text :class="contentClass">
        <slot></slot>
      </v-card-text>
      <v-card-actions v-if="!hideActions">
        <v-spacer></v-spacer>
        <slot name="actions">
          <v-btn color="blue darken-1" flat @click.native="show = false">{{ $t('Close') }}</v-btn>
        </slot>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: Boolean,
    maxWidth: {
      type: String,
      default: '800px'
    },
    hideActions: Boolean,
    noPadding: Boolean,
    lazy: Boolean
  },
  data() {
    return {
      show: this.value
    }
  },
  computed: {
    contentClass() {
      return this.noPadding ? 'pa-0' : '';
    }
  },
  watch: {
    value(val) {
      this.show = val;
    },
    show(val) {
      this.$emit('input', val);
    }
  }
}
</script>
